<template>
  <v-navigation-drawer
    v-model="drawer"
    :color="color"
    :mini-variant="miniVariant"
    :drawer="drawer"
    permanent
    dark
    fixed
    :app="true"
    stateless
  >
    <v-row>
      <v-spacer />
      <v-col
        class="pb-0 pt-8"
        cols="10"
      >
        <img
          v-if="miniVariant"
          src="@/assets/plus.png"
          width="35"
        >
        <img
          v-else
          src="@/assets/balanced-logo-white.svg"
          width="200"
        >
      </v-col>
      <v-spacer />
    </v-row>
    <v-row>
      <v-col class="pt-0 pb-6 text-center">
        <span
          v-if="!miniVariant"
          style="color: white; font-size: 14px;"
        >v{{ appVersion }}</span>
      </v-col>
    </v-row>

    <v-list v-if="!miniVariant" dense nav :style="miniVariant ? 'padding-left: 0px !important;' : ''">
      <v-list-item-group>
        <template>
          <div v-for="(item, index) in items" :key="item.key">
            <v-list-item :to="item.link" :style="item.style">
              <v-row>
                <v-col class="pt-4 pb-4">
                  <v-row align="center">
                    <v-col cols="auto" class="pr-0 pt-2">
                      <v-icon :color="item.iconColor || ''" :style="item.iconStyle">
                        {{ item.icon }}
                      </v-icon>
                    </v-col>
                    <v-col style="padding-right: 0px;">
                      <span :style="`font-size: 14px; font-weight: 500; ${item.style ? item.style : ''}`">{{ item.title }}</span>
                    </v-col>
                    <v-col v-if="item.subItems && item.subItems.length > 0" cols="auto" class="pr-1 pl-0">
                      <v-btn
                        small
                        style="background: transparent;"
                        elevation="0"
                        @click="toggleItemOpen(item)"
                        @click.prevent
                      >
                        <v-icon small style="color: #FFFFFF;">
                          fas fa-angle-down
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-container v-if="item.equipment && item.isOpen" class="pa-0 mt-2">
                    <v-list-item
                      v-for="subItem in item.subItems"
                      :key="subItem.key"
                      active-class="sub-item-selected"
                      class="navbar-subitem"
                      @click="openEquipmentMovementForm(subItem.title)"
                    >
                      <v-list-item-icon class="mb-0">
                        <v-icon small>
                          {{ subItem.icon }}
                        </v-icon>
                      </v-list-item-icon>
                      <div style="font-size: 0.75rem">
                        {{ subItem.title }}
                      </div>
                    </v-list-item>
                  </v-container>
                  <v-container
                    v-if="!item.equipment && item.isOpen"
                    class="pa-0 mt-2"
                  >
                    <v-list-item
                      v-for="subItem in item.subItems"
                      :key="subItem.key"
                      :to="subItem.link"
                      active-class="sub-item-selected"
                      class="navbar-subitem"
                      :style="miniVariant ? 'margin-left: 0px !important; padding-left: 6px !important;' : ''"
                      @click.stop
                    >
                      <v-list-item-icon
                        class="mb-0"
                      >
                        <v-icon
                          :color="subItem.iconColor ? subItem.iconColor : ''"
                          small
                        >
                          {{ subItem.icon }}
                        </v-icon>
                      </v-list-item-icon>
                      <div
                        :style="`font-size: 0.75rem; ${subItem.style ? subItem.style : ''}`"
                      >
                        {{ subItem.title }}
                      </div>
                    </v-list-item>
                  </v-container>
                </v-col>
              </v-row>
            </v-list-item>
            <!-- eslint-disable-next-line vue/valid-v-for -->
            <v-divider
              v-if="items[index + 1] && items[index + 1].groupId != item.groupId"
              color="#757575"
              class="mt-2 mb-2"
            />
          </div>
        </template>
      </v-list-item-group>
    </v-list>

    <!-- MINI -->
    <v-list v-else dense nav :style="miniVariant ? 'padding-left: 0px !important;' : ''">
      <v-list-item-group>
        <template>
          <div v-for="(item, index) in items" :key="item.key">
            <v-list-item :to="item.link" class="pl-0">
              <v-row>
                <v-col class="pt-4 pb-4">
                  <v-row align="center">
                    <v-col cols="auto" class="pr-0 pt-2">
                      <v-tooltip v-if="miniVariant" right>
                        <template #activator="{ on }">
                          <v-icon
                            :color="item.iconColor ? item.iconColor : ''"
                            v-on="on"
                          >
                            {{ item.icon }}
                          </v-icon>
                        </template>
                        <span>{{ item.title }}</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                  <v-container
                    v-if="item.equipment && item.isOpen"
                    class="pa-0"
                  >
                    <v-list-item
                      v-for="subItem in item.subItems"
                      :key="subItem.key"
                      active-class="sub-item-selected"
                      class="navbar-subitem"
                      @click="openEquipmentMovementForm(subItem.title)"
                    >
                      <v-list-item-icon style="margin-right: 15px">
                        <v-icon>{{ subItem.icon }}</v-icon>
                      </v-list-item-icon>
                    </v-list-item>
                  </v-container>
                  <v-container
                    v-if="!item.equipment && item.isOpen"
                    class="pa-0 mt-2"
                  >
                    <v-list-item
                      v-for="subItem in item.subItems"
                      :key="subItem.key"
                      :to="subItem.link"
                      active-class="sub-item-selected"
                      class="navbar-subitem"
                      :style="miniVariant ? 'margin-left: 0px !important; padding-left: 6px !important;' : ''"
                      @click.stop
                    >
                      <v-list-item-icon
                        class="mb-0"
                      >
                        <v-icon
                          :color="subItem.iconColor ? subItem.iconColor : ''"
                          small
                        >
                          {{ subItem.icon }}
                        </v-icon>
                      </v-list-item-icon>
                    </v-list-item>
                  </v-container>
                </v-col>
              </v-row>
            </v-list-item>
            <!-- eslint-disable-next-line vue/valid-v-for -->
            <v-divider
              v-if="items[index + 1] && items[index + 1].groupId != item.groupId"
              color="#FFFFFF"
              class="mt-2 mb-2"
            />
          </div>
        </template>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'NavigationDrawer',
  components: { },
  data: () => ({
    drawer: true,
    isEquipmentSubmenuOpen: false,
    color: '#323232',
    miniVariant: false,
    name: '',
    isReportAssigned: false,
    items: [],
  }),
  computed: {
    ...mapGetters([
      'isLoggedIn',
      'getAdminModuleValue',
      'checkUserPermission',
      'checkUserPermissionExcept',
      'isPhysicalCountActivated',
      'businessRulesGetBoolean',
    ]),
    ...mapState({
      adminModules: (state) => state.admin_modules,
      userId: (state) => state.user.id,
    }),

    appVersion() {
      return this.$store.getters.appVersion;
    },
  },
  watch: {
    adminModules: {
      handler() {
        this.get();
      },
      deep: true,
    },
  },
  created() {
    if (!this.isLoggedIn) return;
    this.get();
  },
  methods: {

    get() {
      const items = [];

      // remove read, read-write later
      const clientPermission = this.checkUserPermission(['Admin', 'Associate', 'Read', 'Read-Write']);
      const clientValue = this.getAdminModuleValue('Clients');
      let clientTitle = 'CLIENTS';
      const supplierValue = this.getAdminModuleValue('Suppliers');
      if (supplierValue) clientTitle = 'CLIENTS / SUPPLIERS';

      if (clientPermission && clientValue) {
        items.push({
          icon: 'fas fa-address-card',
          title: clientTitle,
          key: 1,
          link: '/clients',
          iconStyle: 'font-size: 20px; padding-top: 4px;',
          groupId: 1,
        });
      }

      const scopeOfProjectPermission = this.checkUserPermission(['Admin', 'Associate', 'Estimator', 'Project Manager', 'Paint Handler', 'Read-Write']);
      const scopeOfProjectValue = this.getAdminModuleValue('Projects');
      if (scopeOfProjectPermission && scopeOfProjectValue) {
        items.push({
          icon: 'mdi-ruler',
          title: 'PROJECTS',
          key: 13,
          link: '/projects',
          iconStyle: 'font-size: 24px;',
          groupId: 1,
        });
      }

      // remove read, read-write later
      const jobPermission = this.checkUserPermission(['Admin', 'Associate', 'Read', 'Read-Write']);
      const jobValue = this.getAdminModuleValue('Jobs');
      if (jobPermission && jobValue) {
        items.push({
          icon: 'fas fa-suitcase',
          title: this.businessRulesGetBoolean('Jobs Rename to Release') ? 'RELEASES' : 'JOBS',
          key: 2,
          link: '/jobs',
          iconStyle: 'font-size: 22px; padding-right: 2px;',
          groupId: 1,
        });
      }

      const inventoryPermission = this.checkUserPermission(['Admin', 'Associate', 'Material Handler', 'Material Requester', 'Purchaser', 'Paint Handler']);
      const inventoryValue = this.getAdminModuleValue('Inventory');
      if (inventoryPermission && inventoryValue) {
        const inventoryItem = {
          icon: 'fas fa-boxes',
          title: 'INVENTORY',
          key: 5,
          link: '/inventory',
          isOpen: true,
          subItems: [],
          iconStyle: 'font-size: 20px; padding-right: 3px;',
          groupId: 1,
        };

        if (this.getAdminModuleValue('Inventory Allocation') && this.checkUserPermission(['Admin', 'Allocation Admin', 'Material Handler', 'Material Requester'])) {
          inventoryItem.subItems.push({ icon: 'fas fa-qrcode', title: 'ALLOCATION', 'key': 1001, link: '/inventory-allocation', iconColor: 'purple' });
        }

        const inventoryQrPermission = this.checkUserPermission(['Admin', 'Associate', 'Material Handler', 'Paint Handler']);
        const inventoryQrValue = this.getAdminModuleValue('Inventory Qr');
        if (inventoryQrPermission && inventoryQrValue && !this.isPhysicalCountActivated) {
          inventoryItem.subItems.push({
            icon: 'fas fa-qrcode',
            title: 'INVENTORY QR',
            key: 100,
            link: '/inventory-qr',
          });
        }

        const physicalCountQrPermission = this.checkUserPermission(['Admin', 'Associate', 'Physical Count Handler']);
        const physicalCountQrValue = this.getAdminModuleValue('Physical Count Qr');
        if (physicalCountQrPermission && physicalCountQrValue) {
          inventoryItem.subItems.push({
            icon: 'fas fa-qrcode',
            iconColor: 'pink',
            title: 'PHYSICAL COUNT QR',
            key: 101,
            link: '/physical-count-qr',
          });
        }

        const rmReceivingQrPermission = this.checkUserPermission(['Admin', 'Associate', 'RM Receiving Handler', 'Paint Handler']);
        const rmReceivingQrValue = this.getAdminModuleValue('RM Receiving');
        if (rmReceivingQrPermission && rmReceivingQrValue && !this.isPhysicalCountActivated) {
          inventoryItem.subItems.push({
            icon: 'fas fa-qrcode',
            iconColor: 'green',
            title: 'RM RECEIVING',
            key: 102,
            link: '/rm-receiving-qr',
          });
        }

        const movingPermission = this.checkUserPermission(['Admin', 'Associate', 'Moving Handler']);
        const movingValue = this.getAdminModuleValue('Moving');
        if (movingPermission && movingValue && !this.isPhysicalCountActivated) {
          inventoryItem.subItems.push({
            icon: 'fas fa-qrcode',
            iconColor: 'yellow',
            title: 'MOVING QR',
            key: 103,
            link: '/moving-qr',
          });
        }

        const stlQrPermission = this.checkUserPermission(['Admin', 'Associate', 'Material Handler']);
        const stlQrValue = this.getAdminModuleValue('STL QR');
        if (stlQrPermission && stlQrValue) {
          inventoryItem.subItems.push({
            icon: 'fas fa-qrcode',
            iconColor: 'teal',
            title: 'STL QR',
            key: 104,
            link: '/stl-qr',
          });
        }

        const poPermission = this.checkUserPermission(['Admin', 'Purchaser']);
        const poValue = this.getAdminModuleValue('Inventory PO');
        if (poPermission && poValue) {
          inventoryItem.subItems.push({
            icon: 'fas fa-clipboard-check',
            title: 'INVENTORY PO',
            key: 105,
            link: '/inventory-po',
          });
        }

        const poInstPermission = this.checkUserPermission(['Admin', 'Purchaser']);
        const poInstValue = this.getAdminModuleValue('Installation PO');
        if (poInstPermission && poInstValue) {
          inventoryItem.subItems.push({
            icon: 'mdi-clipboard-text-clock',
            title: 'INSTALLATION PO',
            key: 106,
            link: '/installation-po',
            iconColor: '#2196F2',
            style: 'color: #2196F2; font-weight: 600;',
          });
        }

        items.push(inventoryItem);
      }

      const glassPermission = this.checkUserPermission(['Admin', 'Associate', 'Glass Handler', 'Glass Manager', 'Glass Supervisor', 'Read', 'Read-Write', 'Purchaser', 'Project Manager']);
      const glassValue = this.getAdminModuleValue('Glass');

      if (glassValue) {
        const batchQrValue = this.getAdminModuleValue('Batch Qr');
        const movingPermission = this.checkUserPermission(['Admin', 'Associate', 'Material Handler', 'Glass Handler', 'Glass Supervisor']);
        const packagingSlipValue = this.getAdminModuleValue('Packaging Slip');
        const packagingSlipPermission = this.checkUserPermission(['Admin', 'Associate', 'Glass Handler', 'Material Handler']);
        const packagingSlipQrValue = this.getAdminModuleValue('Packaging Slip QR');
        const packagingSlipQrPermission = this.checkUserPermission(['Admin', 'Associate', 'Glass Handler']);

        const subItems = [];
        if (this.checkUserPermission(['Admin', 'Associate', 'Glass Handler', 'Glass Manager', 'Purchaser'])) {
          subItems.push({ title: 'PO', link: '/glass/po-items', icon: 'fas fa-list', key: 201 });
        }
        if (this.checkUserPermission(['Admin', 'Associate', 'Glass Handler', 'Glass Manager'])) {
          subItems.push({ title: 'ITEMS', link: '/glass/glass-items', icon: 'fas fa-th', key: 202 });
          if (this.getAdminModuleValue('Reject/Rework QR') && movingPermission) subItems.push({ title: 'REJECT / REWORK QR', link: '/glass/glass-move-qr', icon: 'fas fa-qrcode', iconColor: 'purple', key: 203 });
        }
        if (this.checkUserPermission(['Admin', 'Associate', 'Glass Handler']) && this.getAdminModuleValue('Batches')) {
          subItems.push({ title: 'BATCHES', link: '/glass/batches', icon: 'fas fa-layer-group', key: 205 });
        }
        if (batchQrValue && movingPermission) {
          subItems.push({
              title: 'BATCH QR',
              link: '/glass/batch-qr',
              icon: 'fas fa-qrcode',
              iconColor: 'blue',
              key: 204,
            });
        }
        if (packagingSlipValue && packagingSlipPermission) {
          subItems.push({ title: 'PACKING SLIP', link: '/glass/packaging-slips', icon: 'fas fa-box-open', key: 2051 });
        }
        if (packagingSlipQrValue && packagingSlipQrPermission) {
          subItems.push({ title: 'PACKING SLIP QR', link: '/glass/packaging-slip-qrs', iconColor: 'orange', icon: 'fas fa-qrcode', key: 206 });
        }

        if (glassPermission || subItems.length > 0) {
          items.push({
            icon: 'mdi-checkbox-blank',
            title: 'GLASS',
            link: glassPermission ? '/glass' : undefined,
            key: 20,
            iconStyle: 'padding-right: 2px;',
            isOpen: true,
            groupId: 1,
            subItems
          });
        }
      }

      const panelsPermission = this.checkUserPermission(['Admin', 'Panel Admin', 'Panel Supervisor']);
      const panelsValue = this.getAdminModuleValue('WIP Panel');
      if (panelsPermission && panelsValue) {
        items.push({
          icon: 'mdi-checkbox-blank',
          title: 'PANELS',
          key: 600,
          iconStyle: 'padding-right: 2px;',
          iconColor: 'grey',
          isOpen: true,
          groupId: 1,
          subItems: [
            { title: 'CURRENT', link: '/wip-panel-schedules/1', icon: 'mdi-arrow-right-drop-circle', key: 607 },
            { title: 'ON HAND', link: '/wip-panel-schedules/3', icon: 'mdi-inbox', key: 608 },
            { title: 'ARCHIVED', link: '/wip-panel-schedules/2', icon: 'mdi-archive', key: 609 },
            { title: 'CALENDAR', link: '/wip-panel-schedule-calendar', icon: 'far fa-calendar-alt', key: 610 },
            { title: 'BATCHES', link: '/wip-panels/batches', icon: 'fas fa-layer-group', key: 603 },
            { title: 'BATCH QR', link: '/wip-panels/batch-qr', icon: 'fas fa-qrcode', iconColor: 'blue', key: 604 },
            { title: 'PACKING SLIP', link: '/wip-panels/packing-slips', icon: 'fas fa-box-open', key: 605 },
            { title: 'PACKING SLIP QR', link: '/wip-panels/packing-slip-qrs', iconColor: 'orange', icon: 'fas fa-qrcode', key: 606 },
            { title: 'AD HOC REQUESTS', link: '/wip-panels/ad-hoc-requests', icon: 'fas fa-box-open', key: 6007 },
          ],
        });
      }

      const screenSchedulePermission = this.checkUserPermission(['Admin', 'Associate', 'Screen Supervisor', 'Read', 'Spandrel Paint Supervisor', 'Screen Admin']);
      const screenScheduleValue = this.getAdminModuleValue('Screen Schedule');
      if (screenSchedulePermission && screenScheduleValue) {
        items.push({
          icon: 'mdi-fit-to-screen',
          title: 'SCREENS',
          key: 60,
          isOpen: true,
          iconStyle: 'padding-right: 2px;',
          groupId: 1,
          style: 'padding-right: 0px;',
          subItems: [
            { title: 'CURRENT', link: '/screen-schedules/1', icon: 'mdi-arrow-right-drop-circle', key: 600 },
            { title: 'ON HAND', link: '/screen-schedules/3', icon: 'mdi-inbox', key: 6001 },
            { title: 'ARCHIVED', link: '/screen-schedules/2', icon: 'mdi-archive', key: 6002 },
            { title: 'CALENDAR', link: '/screen-schedule-calendar', icon: 'far fa-calendar-alt', key: 6003 },
            { title: 'BILL OF LADING', link: '/screen-bill-of-lading', icon: 'fas fa-file-invoice', key: 6004 },
            { title: 'BILL OF LADING QR', link: '/screen-bill-of-lading-qr', icon: 'fas fa-qrcode', iconColor: 'cyan', key: 6005 },
            { title: 'SCREEN BATCH QR', link: '/screen-qr', icon: 'fas fa-qrcode', iconColor: 'grey', key: 6006 },
          ],
        });
      }

      const supplyReturnPermission = this.checkUserPermission(['Admin', 'Associate', 'Material Handler']);
      const supplyReturnValue = this.getAdminModuleValue('RM Supply / Return');
      if (supplyReturnPermission && supplyReturnValue && !this.isPhysicalCountActivated) {
        items.push({
          icon: 'fas fa-truck-loading',
          title: 'STL - SUPPLY / RETURN',
          key: 3,
          link: '/consumptions',
          iconStyle: 'font-size: 18px; padding-right: 2px;',
          groupId: 2,
        });
      }

      const partPickListPermission = this.checkUserPermission(['Admin', 'Associate', 'Picker', 'Requester']);
      const partPickListValue = this.getAdminModuleValue('Part Pick List');
      if (partPickListPermission && partPickListValue) {
        items.push({
          icon: 'mdi-format-list-checks',
          title: 'PL - PICK LIST',
          key: 14,
          link: '/part-pick-lists',
          groupId: 2,
        });
      }

      const supplyPaintPermission = this.checkUserPermission(['Admin', 'Associate', 'Material Handler']);
      const supplyPaintValue = this.getAdminModuleValue('Supply To Paint');
      if (supplyPaintPermission && supplyPaintValue) {
        items.push({
          icon: 'mdi-spray',
          title: 'STP - SUPPLY TO PAINT',
          key: 4,
          link: '/supply-to-paints',
          iconStyle: 'font-size: 22px; padding-left: 0px; padding-right: 3px;',
          groupId: 2,
        });
      }

      const truckSchedulePermission = this.checkUserPermission(['Admin', 'Associate', 'Approver', 'Requester', 'Shipper', 'Installer', 'Production Admin', 'Deliveries Manager', 'Deliveries View', 'Deliveries Requester']);
      // const truckScheduleRequestsPermission = this.checkUserPermission(['Admin', 'Associate', 'Approver', 'Requester', 'Shipper', 'Installer']);
      // const truckScheduleSchedulePermission = this.checkUserPermission(['Admin', 'Associate', 'Approver', 'Requester', 'Shipper', 'Installer']);
      const truckScheduleDeliveriesPermission = this.checkUserPermission(['Admin', 'Deliveries Manager', 'Deliveries View', 'Deliveries Requester']);
      const truckScheduleTrucksPermission = this.checkUserPermission(['Admin', 'Deliveries Manager', 'Deliveries View', 'Deliveries Requester']);
      const truckScheduleBackorderPermission = this.checkUserPermission(['Admin', 'Deliveries Manager']);
      const billOfLadingPermission = this.checkUserPermission(['Admin', 'Shipper', 'Production Admin']);
      const truckScheduleValue = this.getAdminModuleValue('Truck Schedule');
      if (truckSchedulePermission && truckScheduleValue) {
        const subItems = [];
        if (truckScheduleDeliveriesPermission) subItems.push({ title: 'DELIVERIES', link: '/truck-schedules/deliveries', icon: 'mdi-truck-delivery', key: 400 });
        if (billOfLadingPermission) {
          subItems.push({ title: 'BILL OF LADING', link: '/truck-schedules/bill-of-lading', icon: 'fas fa-file-invoice', key: 401 });
          subItems.push({ title: 'BILL OF LADING QR', link: '/truck-schedules/bill-of-lading-qrs', icon: 'fas fa-qrcode', iconColor: 'cyan', key: 402 });
        }
        if (truckScheduleBackorderPermission) subItems.push({ title: 'BACKORDER', link: '/truck-schedules/backorders', icon: 'mdi-calendar-arrow-left', key: 403 });
        if (truckScheduleTrucksPermission) subItems.push({ title: 'TRUCKS', link: '/truck-schedules/trucks', icon: 'mdi-truck', key: 404 });

        items.push({
          icon: 'mdi-truck',
          title: 'TRUCK SCHEDULE',
          key: 40,
          isOpen: true,
          iconStyle: 'font-size: 22px; padding-right: 2px; padding-left: 2px;',
          groupId: 3,
          subItems,
        });
      }

      const productionSchedulePermission = this.checkUserPermission(['Admin', 'Associate', 'Production Supervisor', 'Read', 'Spandrel Paint Supervisor', 'Production Admin']);
      const productionScheduleValue = this.getAdminModuleValue('Production Schedule');
      if (productionSchedulePermission && productionScheduleValue) {
        items.push({
          icon: 'mdi-package-down',
          title: 'PROD SCHEDULE',
          key: 50,
          isOpen: true,
          iconStyle: 'padding-right: 2px;',
          groupId: 3,
          subItems: [
            { title: 'CURRENT', link: '/production-schedules/1', icon: 'mdi-arrow-right-drop-circle', key: 500 },
            { title: 'ON HAND', link: '/production-schedules/3', icon: 'mdi-inbox', key: 5001 },
            { title: 'ARCHIVED', link: '/production-schedules/2', icon: 'mdi-archive', key: 5002 },
            { title: 'CALENDAR', link: '/production-schedule-calendar', icon: 'far fa-calendar-alt', key: 5003 },
            { title: 'OVERVIEW', link: '/production-schedule-overview', icon: 'far fa-window-restore', key: 5005 },
          ],
        });
      }

      const windowScanningPermission = this.checkUserPermission(['Admin', 'Associate', 'Production Supervisor', 'Read', 'Production Admin']);
      const windowScanningValue = this.getAdminModuleValue('Window Scanning');
      if (windowScanningPermission && windowScanningValue) {
        const index = items.findIndex((item) => item.key === 50);
        if (index !== -1) {
          items[index].subItems.push({
            title: 'PRODUCTION QR', link: '/production-qrs', icon: 'fas fa-qrcode', iconColor: 'red', key: 5004,
          });
        }
      }

      //Commercial (Curtainwall) Schedule
      const commercialSchedulePermission = this.checkUserPermission(['Admin', 'Curtainwall Schedule Admin', 'Curtainwall Schedule Supervisor', 'Associate']);
      const commercialScheduleValue = this.getAdminModuleValue('Curtainwall Schedule');
      if (commercialSchedulePermission && commercialScheduleValue) {
        items.push({
          icon: 'mdi-layers',
          title: 'CURTAINWALL SCHEDULE',
          iconColor: 'teal',
          key: 7000,
          isOpen: true,
          iconStyle: 'padding-right: 2px;',
          groupId: 3,
          subItems: [
            {
              title: 'CURRENT', link: '/curtainwall-schedules/1', icon: 'mdi-arrow-right-drop-circle', key: 7001,
            },
            {
              title: 'ON HAND', link: '/curtainwall-schedules/3', icon: 'mdi-inbox', key: 7003,
            },
            {
              title: 'ARCHIVED', link: '/curtainwall-schedules/2', icon: 'mdi-archive', key: 7002,
            },
            {
              title: 'CALENDAR', link: '/curtainwall-schedule-calendar', icon: 'far fa-calendar-alt', key: 7004,
            },
            {
              title: 'BUNDLE', link: '/curtainwall-bundle', icon: 'fas fa-box', key: 7005,
            },
            // {
            //   title: 'BUNDLE QR', link: '/commercial-bundle-qr', icon: 'fas fa-qrcode', iconColor: 'yellow', key: 7006,
            // },
            {
              title: 'SKID', link: '/curtainwall-skid', icon: 'fas fa-pallet', key: 7007,
            },
            // {
            //   title: 'SKID QR', link: '/commercial-skid-qr', icon: 'fas fa-qrcode', iconColor: 'orange', key: 7008,
            // },
            {
              title: 'BILL OF LADING', link: '/curtainwall-bill-of-lading', icon: 'fas fa-file-invoice', key: 7009,
            },
            {
              title: 'BILL OF LADING QR', link: '/curtainwall-bill-of-lading-qr', icon: 'fas fa-qrcode', iconColor: 'cyan', key: 7010,
            },
            {
              title: 'CURTAINWALL QR', link: '/curtainwall-qrs', icon: 'fas fa-qrcode', iconColor: 'teal', key: 7011,
            },
          ],
        });
      }

      const cncFilesPermission = this.checkUserPermission(['Admin', 'Associate']);
      const cncFilesValue = this.getAdminModuleValue('CNC Files');
      if (cncFilesPermission && cncFilesValue) {
        items.push({
          icon: 'fas fa-file-import',
          title: 'CNC FILES',
          key: 11,
          link: '/cnc-files',
          iconStyle: 'font-size: 20px; padding-right: 5px;',
          groupId: 4,
        });
      }

      const cutSheetPermission = this.checkUserPermission(['Admin', 'Associate', 'Cut Sheet Handler', 'Panel Admin', 'Panel Supervisor', 'Curtainwall Schedule Admin', 'Curtainwall Schedule Supervisor']);
      const cutSheetValue = this.getAdminModuleValue('Cut Sheets');
      if (cutSheetPermission && cutSheetValue) {
        items.push({
          icon: 'fas fa-file-alt',
          title: 'CUT SHEETS',
          key: 12,
          link: '/cut-sheets',
          iconStyle: 'font-size: 20px; padding-right: 5px; padding-left: 5px;',
          groupId: 4,
        });
      }

      const accountingPermission = this.checkUserPermission(['Accountant']);
      const accountingValue = this.getAdminModuleValue('Accounting');
      if (accountingPermission && accountingValue) {
        const accountingOrdersValue = this.getAdminModuleValue('Accounting Orders');
        const invoicesValue = this.getAdminModuleValue('Invoices');
        const shippingReportValue = this.getAdminModuleValue('Shipping Report');

        const subItems = [];
        if (accountingOrdersValue) subItems.push({ title: 'ORDERS', link: '/accounting/orders', icon: 'fas fa-file-invoice-dollar', key: 181 });
        if (invoicesValue) subItems.push({ title: 'INVOICES', link: '/accounting/invoices', icon: 'fas fa-dollar-sign', key: 182 });
        if (shippingReportValue) subItems.push({ title: 'SHIPPING REPORTS', link: '/accounting/shipping-reports', icon: 'mdi-invoice-text-send', key: 183 });

        items.push({
          icon: 'fas fa-calculator',
          title: 'ACCOUNTING',
          key: 18,
          iconStyle: 'font-size: 20px; padding-right: 6px; padding-left: 5px;',
          groupId: 5,
          isOpen: true,
          subItems,
        });
      }

      const reportPermission = this.checkUserPermission(['Admin', 'Associate', 'Moving Handler', 'RM Receiving Handler', 'Physical Count Handler', 'Glass Handler']);
      const reportValue = this.getAdminModuleValue('Reports');
      if (reportPermission && reportValue) {
        items.push({
          icon: 'fas fa-file',
          title: 'REPORTS',
          key: 10,
          link: '/reports',
          iconStyle: 'font-size: 20px; padding-right: 6px; padding-left: 5px;',
          groupId: 5,
        });
      }

      const dashboardPermission = this.checkUserPermission(['Admin', 'Associate', 'Production Admin', 'Dashboards']);
      const dashboardValue = this.getAdminModuleValue('Dashboard');
      if (dashboardPermission && dashboardValue) {
        items.push({
          icon: 'mdi-chart-bar',
          title: 'DASHBOARD',
          key: 16,
          link: '/dashboards',
          iconStyle: 'font-size: 20px; padding-right: 6px; padding-left: 5px;',
          groupId: 5,
        });
      }

      const timeOffPermission = this.checkUserPermission(['Time-Off User', 'Time-Off Supervisor', 'Time-Off Accountant', 'HR', 'Time-Off Director']);
      const timeOffValue = this.getAdminModuleValue('Time Off');
      if (timeOffPermission && timeOffValue) {
        items.push({
          icon: 'fas fa-clock',
          title: 'TIME OFF',
          key: 17,
          link: '/time-offs',
          iconStyle: 'font-size: 20px; padding-right: 6px; padding-left: 5px;',
          groupId: 5,
        });
      }

      const vmsPermission = this.checkUserPermission(['Admin', 'Associate', 'VMS Admin']);
      const vmsValue = this.getAdminModuleValue('VMS');
      if (vmsPermission && vmsValue) {
        items.push({
          icon: 'mdi-account-group',
          title: 'VMS',
          key: 1800,
          link: '/vms',
          iconStyle: 'font-size: 20px; padding-right: 6px; padding-left: 5px;',
          groupId: 5,
        });
      }

      const stmsPermission = this.checkUserPermission(['Admin', 'Associate', 'Service Manager']);
      const stmsValue = this.getAdminModuleValue('STMS');
      if (stmsPermission && stmsValue) {
        items.push({
          icon: 'mdi-email',
          title: 'SERVICE',
          key: 19,
          link: '/stms-requests',
          iconStyle: 'font-size: 20px; padding-right: 6px; padding-left: 5px;',
          groupId: 5,
        });
      }

      // remove read, read-write later
      const equipmentPermission = this.checkUserPermission(['Admin', 'Associate', 'Equipment Handler', 'Read', 'Read-Write']);
      const equipmentValue = this.getAdminModuleValue('Equipment');
      if (equipmentPermission && equipmentValue) {
        items.push({
          title: 'EQUIPMENT',
          icon: 'fas fa-hammer',
          link: '/equipment',
          key: 30,
          equipment: true,
          isOpen: true,
          subItems: [
            { title: 'CHECK - IN', icon: 'fas fa-arrow-right', key: 300 },
            { title: 'CHECK - OUT', icon: 'fas fa-arrow-left', key: 301 },
            { title: 'CHANGE SITE', icon: 'fas fa-random', key: 302 },
            { title: 'REQUEST REPAIR', icon: 'fas fa-tools', key: 303 },
            { title: 'REPAIR DONE', icon: 'fas fa-check', key: 304 },
          ],
        });
      }

      this.items = items;
    },

    openEquipmentMovementForm(type) {
      this.$bus.$emit('openEquipmentMovementForm', type);
      // this.$store.commit('openEquipmentMovementForm', type);
    },

    logout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/login');
      });
    },

    redirect(path) {
      this.$router.push(path);
    },

    menuActionClick(actionName) {
      if (!actionName) return;
      if (actionName === 'logout') {
        this.logout();
      }
    },

    toggleItemOpen(item) {
      const index = this.items.findIndex((x) => x.key === item.key);
      if (index === -1) return;
      this.items[index].isOpen = !this.items[index].isOpen;
      this.$set(this.items, index, this.items[index]);
    },
  },
};
</script>

<style scoped>
/* ::v-deep .navbar-grouped .theme--dark.v-list-item--active:hover::before, .theme--dark.v-list-item--active::before {
    opacity: 0 !important;
} */
::v-deep .navbar-grouped .v-list-group__header.v-list-item--active:not(:hover):not(:focus):before {
    opacity: 0 !important;
}
::v-deep .navbar-grouped .v-list-group__header
{
  padding: 0px;
}
::v-deep .navbar-grouped .theme--dark.v-list-item--active:hover::before, .theme--dark.v-list-item--active::active {
    opacity: 0 !important;
}
::v-deep .navbar-grouped .v-list-group__header.v-list-item--active:not(:hover):not(:focus):active {
    opacity: 0 !important;
}

::v-deep .navbar-grouped .v-list-item--link:before {
  background-color: transparent !important;
}
.navbar-grouped-item {
  width: 100%;
}

.navbar-grouped-item >>> div {
  padding: 0;
}

.navbar-item-icon {
  width: 1.5rem;
}

.navbar-subitem {
  margin-left: 2rem;
  max-height: 10px !important;
}

.logo-size {
  max-width: 30px;
}

::v-deep .sub-item-selected{
  background-color: rgba(215, 215, 215, 0.2) !important;
}

::v-deep .v-list-item--dense .v-list-item__icon, .v-list--dense .v-list-item .v-list-item__icon {
    width: 10px !important;
}

::v-deep .v-application--is-ltr .v-list-item__action:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__avatar:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
    margin-left: 0px !important;
}

::v-deep .v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
    min-width: 20px !important;
    max-width: 20px !important;
}

::v-deep .v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child
{
    margin-right: 10px !important;
    margin-top: 2px !important;
}

.gradient-text {
  background-image: linear-gradient(60deg, #a100d6, #fc9b0e, #51bafa #39ffc8);
  background-clip: text;
  color: transparent;
}

.v-list-item--dense, .v-list--dense .v-list-item {
    min-height: 30px;
}

.v-list-item--dense .v-list-item__icon, .v-list--dense .v-list-item .v-list-item__icon {
    height: 24px;
    margin-top: 6px;
    margin-bottom: 6px;
}
</style>
